import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { login as apiLogin, getMe, tokenStore } from "@/services/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  // undefined = checking, null = not authenticated, object = authenticated
  const [user, setUser] = useState(undefined);

  const bootstrap = useCallback(async () => {
    if (!tokenStore.get()) {
      setUser(null);
      return;
    }
    try {
      const me = await getMe();
      setUser(me);
    } catch {
      tokenStore.clear();
      setUser(null);
    }
  }, []);

  useEffect(() => {
    bootstrap();
  }, [bootstrap]);

  const signIn = async (email, password) => {
    const data = await apiLogin(email, password);
    tokenStore.set(data.token);
    setUser(data.user);
    return data.user;
  };

  const signOut = () => {
    tokenStore.clear();
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, signIn, signOut, isChecking: user === undefined }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
